import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../utils/loader/loader.component';
import { CustomTableComponent } from '../../../utils/custom-table/custom-table.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';
import { PaymentService } from '../../../services/payment.service';
import { ThemeService } from '../../../theme.service';
import { Title } from '@angular/platform-browser';
import { CustomTableIconComponent } from "../../../utils/custom-table-icon/custom-table-icon.component";
import { ReportsServicesService } from '../../../services/reports-services.service';
import { environment } from '../../../../environments/environment';
import { AlertModalComponent } from "../../../utils/alert-modal/alert-modal.component";
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'app-payment',
    imports: [LoaderComponent, CustomTableComponent, NgxMaskDirective, FormsModule, CustomTableIconComponent, AlertModalComponent, ButtonModule, InputTextModule],
    templateUrl: './payment.component.html',
    styleUrl: './payment.component.scss',
    providers: [provideNgxMask()]
})
export class PaymentComponent implements AfterViewInit {
  loading = false;
  movements: any[] = [];
  invoices: any[] = [];
  selectedInvoices: any[] = [];
  allCards: any = [];
  pendingPayments: any[] = [];
  selectedPayment: any;
  messageModal = '';
  totalAmountForm = 0;
  paymentService = 2;
  mpUrl = environment.multipagos_url;
  urlWebhook = environment.apiUrl + 'Payment/webhook'
  enProceso = false;
  @ViewChild('paymentForm')
  formElement!: ElementRef;
  msgDisabled = '';

  headers: any[] = [
    { key: "date", textHeader: "Fecha", visible: true, type: "date" },
    { key: "reference", textHeader: "Referencia", visible: true, type: "string" },
    { key: "abono", textHeader: "Abono", visible: true, type: "currency" }
  ];

  headersPayment: any[] = [
    { key: "date", textHeader: "Fecha", visible: true, type: "date" },
    { key: "number", textHeader: "Referencia", visible: true, type: "string" },
    { key: "amount", textHeader: "Total", visible: true, type: "currency" }
  ];

  headersCredit: any[] = [

    { key: "dueDate", textHeader: "Vencimiento", visible: true, type: "date" },
    { key: "serieFolio", textHeader: "Factura", visible: true, type: "string" },
    { key: "total", textHeader: "Importe", visible: true, type: "currency" },
    { key: "balance", textHeader: "Saldo", visible: true, type: "currency" },
    { key: "id", textHeader: "Seleccionar", visible: true, }


  ];

  actionsPending = [
    {
      text: 'Finalizar pago',
      action: (event: any) => this.doPendingPayment(event),
      icon: undefined,
      hasIcon: false,
      color: "",
      showText: true,
    }
  ]


  fromDate!: Date;
  toDate!: Date;
  fromDateRequest!: Date;
  toDateRequest!: Date;
  selectedCard = -1;
  data: any;
  tokenAuth: any;
  amount = '';
  showMessageError = false;
  messageType = 0;
  searchingPending = false;



  ngOnInit() {
    
    let today = new Date();
    this.fromDate = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
    this.toDate = today;
    this.getPayments();
    this.getPendingPayments();
    this.getPaymentsConfiguration();

  }
  constructor(private service: PaymentService, private rptService: ReportsServicesService, private themeService: ThemeService, private titleService: Title) {


    this.data = JSON.parse(localStorage.getItem('data')!);


    if (this.data.DisableWebPayment == "1") {
      this.showMessageError = true;
      this.msgDisabled = "Tu cuenta está deshabilitada para realizar pagos en línea, comuníquese con atención a cliente si tiene alguna duda.";
    }

    if (this.data.PurchaseType == 'Credit') {
      this.themeService.setTitle("Pago de Facturas");
      this.titleService.setTitle("Pago - Facturas");
    } else {
      this.themeService.setTitle("Agregar Saldo");
      this.titleService.setTitle("Agregar Saldo");
    }

  }
  ngAfterViewInit(): void {
    //this.formElement.nativeElement.style.display = 'none';
  }

  calculatePayment(data: any) {
    console.log(data);
    let totalAmount = 0;
    this.amount = ''
    this.selectedInvoices = [];
    if (data.length > 0) {
      data.forEach((invoice: any) => {

        if (invoice.type != 0) {
          totalAmount += invoice.balance;
          this.selectedInvoices.push(invoice.reference)
        }
      });

      if (totalAmount > 0) {
        this.amount = totalAmount.toFixed(2);
      } else {
        this.amount = '';
      }

    } else {
      this.amount = '';
    }
  }

  setDatesOnFilter(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;
  }

  changeDeviceFilter(event: any, isFromCard: boolean) {
    this.selectedCard = event.value;
  }





  getPayments() {
    this.loading = true;

    if (this.data.PurchaseType == 'Credit') {
      this.fromDateRequest = new Date(this.fromDate.getFullYear() - 1, this.fromDate.getMonth(), this.fromDate.getDate());
      this.toDateRequest = new Date(this.toDate);
      this.rptService.getStataments(this.data.Client_id, this.fromDateRequest, this.toDateRequest).subscribe({
        next: (resp: any) => {

          const invoicesWithType = resp.map((item: any) => {
            return { ...item, type: 0 };
          });


          this.invoices = invoicesWithType.filter((i: any) => i.balance > 0);

          this.loading = false;
        },
        error: (err: any) => {
          this.invoices = [];
          this.loading = false;
        }
      });
    } else {
      this.fromDateRequest = new Date(this.fromDate);
      this.toDateRequest = new Date(this.toDate);

      this.service.getClientMovements(this.data.Client_number, this.fromDateRequest, this.toDateRequest, 'Remission').subscribe({
        next: (resp: any) => {


          this.movements = resp;

          this.loading = false;
        },
        error: (err: any) => {
          this.movements = [];
          this.loading = false;
        }
      });
    }


  }

  doPayment() {

    if (this.amount != '' && parseFloat(this.amount) > 0) {
      this.enProceso = true;
      this.service.validateClientAmount(this.data.Client_number, parseFloat(this.amount), this.selectedInvoices).subscribe({
        next: (resp: any) => {
          this.enProceso = false;
          if (resp.isValid) {

            this.sendData(resp.data.requestForm);
          } else {
            this.messageModal = resp.message;
          }
        },
        error: (err: any) => {
          this.messageModal = 'Hubo un problema para validar el monto a pagar, comuniquese con atención a cliente';
        }
      })
    } else {

    }


  }

  sendData(obj: any) {

    Object.keys(obj).forEach((param) => {

      const mapInput = document.createElement('input');
      mapInput.type = 'hidden';
      mapInput.id = param;
      mapInput.setAttribute('value', obj[param]);
      mapInput.setAttribute('name', param);
      this.formElement.nativeElement.appendChild(mapInput);
    });

    const url_forward = document.createElement('input');
    url_forward.type = 'hidden';
    url_forward.id = "url_forward";

    url_forward.setAttribute('value', environment.urlForward);

    url_forward.setAttribute('name', "url_forward");
    this.formElement.nativeElement.appendChild(url_forward);

    this.formElement.nativeElement.submit();
  }

  getPendingPayments() {
    this.searchingPending = true;
    let today = new Date();
    let yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    let tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    this.service.getPendingPayments(this.data.Client_number, yesterday, tomorrow, 1).subscribe({
      next: (resp: any) => {
        this.searchingPending = false;
        if (resp.length > 0) {
          this.pendingPayments = resp;

        }

      },
      error: (err: any) => {
        this.searchingPending = false;
        console.log(err);
      }
    })
  }

  doPendingPayment(event: any) {

    this.enProceso = true;

    let today = new Date();
    let yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    let tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

    this.service.validatePendingPayment(event.paymentId, this.data.Client_number, yesterday, tomorrow, 1).subscribe({
      next: (resp: any) => {
        this.enProceso = false;
        if (resp.isValid) {

          this.sendData(resp.data.requestForm);
        } else {

        }
      },
      error: (err: any) => {
        this.messageModal = 'Hubo un problema para validar el pago pendiente, comuniquese con atención a cliente';
      }

    })

  }

  getPaymentsConfiguration() {
    this.service.getPaymentsConfiguration().subscribe({
      next: (resp: any) => {
        console.log(resp);
        if (!resp.isSuccess) {
          this.showMessageError = true;
          this.msgDisabled = "Por el momento no se pueden realizar pagos en línea, ya que se está llevando a cabo un mantenimiento en la plataforma de pagos. Comuníquese con atención al cliente para más detalles.";
        }

      },
      error: (err: any) => {
        console.error('Error fetching payment configuration:', err);
      }
    });
  }

}
